module.exports = __webpack_public_path__ + "static/media/MegaMan.58a28f2f.png";